import CardsList from "@/components/cardsList";
import { PlainHoverEffect } from "styles/hoverPresets";
import { IMPLEMENTATION_CONSTANTS } from "./constants";

const Implementation = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      desc={IMPLEMENTATION_CONSTANTS.desc}
      title={IMPLEMENTATION_CONSTANTS.title}
      list={IMPLEMENTATION_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      hoverEffect
      hover={PlainHoverEffect}
    />
  );
};

export default Implementation;
